import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../recommendationsStateSelector";

export const recommendationAppliedProvidersSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.filters.providers;
  },
);
